import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _breakpointValues;

export var edgeValue = 0.05;
export var breakpointUnit = 'px';
export var defaultMediaPrefix = '@media';
export var breakpointKeys = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl'
};
export var breakpointValues = (_breakpointValues = {}, _defineProperty(_breakpointValues, breakpointKeys.xs, 0), _defineProperty(_breakpointValues, breakpointKeys.sm, 600), _defineProperty(_breakpointValues, breakpointKeys.md, 960), _defineProperty(_breakpointValues, breakpointKeys.lg, 1280), _defineProperty(_breakpointValues, breakpointKeys.xl, 1920), _breakpointValues);
export var mapBreakpointCodeToValue = function mapBreakpointCodeToValue(breakpoints, value, spacing) {
  if (typeof value === 'string' && value in breakpoints.values) {
    return "".concat(breakpoints.values[value], "px");
  }

  return spacing(value);
};
export var mapBreakpointWidthToCode = function mapBreakpointWidthToCode(themeBreakpoints, width) {
  var widthProp = width;
  var keys = themeBreakpoints.keys,
      values = themeBreakpoints.values;

  if (typeof widthProp !== 'number') {
    widthProp = parseInt(widthProp, 10);
  }

  if (widthProp <= 0) {
    return keys[0];
  }

  if (widthProp >= values[keys[keys.length - 1]]) {
    return keys[keys.length - 1];
  }

  for (var i = 0; i < keys.length; i += 1) {
    var keyStart = keys[i];
    var keyEnd = keys[i + 1];

    if (widthProp >= values[keyStart] && widthProp < values[keyEnd]) {
      return keyStart;
    }
  }

  return '';
};
export var breakpointUp = function breakpointUp(themeBreakpoints, breakpoint) {
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultMediaPrefix;
  var values = themeBreakpoints.values,
      unit = themeBreakpoints.unit;

  if (!(breakpoint in values)) {
    return '';
  }

  return "".concat(prefix, " (min-width:").concat(values[breakpoint]).concat(unit, ")");
};
export var breakpointDown = function breakpointDown(themeBreakpoints, breakpoint) {
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultMediaPrefix;
  var values = themeBreakpoints.values,
      keys = themeBreakpoints.keys,
      unit = themeBreakpoints.unit;

  if (!(breakpoint in values)) {
    return '';
  }

  var rightIndex = keys.indexOf(breakpoint);
  var rightValue = values[keys[rightIndex]];

  if (rightIndex === keys.length) {
    return breakpointUp(themeBreakpoints, 'xs', prefix);
  }

  if (!(typeof rightValue !== 'undefined' && rightIndex > 0)) {
    return '';
  }

  return "".concat(prefix, " (max-width:").concat(rightValue - edgeValue).concat(unit, ")");
};
export var breakpointBetween = function breakpointBetween(themeBreakpoints, breakpointStart, breakpointEnd) {
  var prefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultMediaPrefix;
  var values = themeBreakpoints.values,
      keys = themeBreakpoints.keys,
      unit = themeBreakpoints.unit;
  var rightIndex = keys.indexOf(breakpointEnd);

  if (rightIndex === keys.length - 1) {
    return breakpointUp(themeBreakpoints, breakpointStart, prefix);
  }

  return "".concat(prefix, " (min-width:").concat(values[breakpointStart]).concat(unit, ") and (max-width:").concat(values[keys[rightIndex + 1]] - edgeValue).concat(unit, ")");
};
export var breakpointOnly = function breakpointOnly(themeBreakpoints, breakpoint) {
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultMediaPrefix;
  return breakpointBetween(themeBreakpoints, breakpoint, breakpoint, prefix);
};
export var forwardBreakpoints = function forwardBreakpoints(breakpoints, fn) {
  return function (code) {
    return fn(breakpoints, code);
  };
};
export var forwardBreakpointsTwoArgs = function forwardBreakpointsTwoArgs(breakpoints, fn) {
  return function (codeStart, codeEnd) {
    return fn(breakpoints, codeStart, codeEnd);
  };
};